<template>
  <article class="projects-view container">
    <h1>{{title}}</h1>
    <div class="mode-buttons">
      <list-icon @click="viewMode = 'list'" :class="{active: viewMode === 'list'}"/>
      <grid-icon @click="viewMode = 'grid'" :class="{active: viewMode === 'grid'}"/>
    </div>
    <Disciplines :discipline.sync="discipline"/>
    <ul class="projects" :class="viewMode">
      <li v-for="(project, index) in filteredProjects()" v-bind:key="index">
        <Project :projectData="project" :viewMode="viewMode" :projectView="'overview'" />
      </li>
    </ul>
  </article>
</template>

<script>
// import { settings } from '../variables.js'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Disciplines from '@/components/Disciplines.vue'
import Project from '@/components/Project.vue'

export default {
  data () {
    return {
      // projects: [],
      viewMode: 'grid',
      discipline: null,
      hasFull: false
    }
  },
  components: {
    Project, Disciplines
  },
  beforeCreate: function () {
    if (!this.$store.state.projectsModule.projects) {
      this.$store.dispatch('projectsModule/getProjects')
    }
  },
  mounted: function () {
    NProgress.done()
  },
  methods: {
    filteredProjects: function () {
      if (this.discipline == null) {
        return this.projects
      } else {
        let filteredProjects = this.projects.filter((project) => {
          return project.disclipline.includes(this.discipline)
        })
        return filteredProjects
      }
    }
  },
  computed: {
    loaded () {
      return !(Object.entries(this.page).length === 0 && this.page.constructor === Object)
    },
    projects () {
      return this.$store.state.projectsModule.projects
    },
    title () {
      return this.$store.state.projectsModule.title
    }
  }
}
</script>

<style lang="scss">
  .projects-view {
    display: flex;
    flex-wrap: wrap;

    &::before {
      content: '';
      margin-right: auto;
      min-width: 100px;
      max-width: 100px;
    }
  }
  .mode-buttons {
    display:flex;
    justify-content: flex-end;
    margin-left: auto;
    font-size: 22px;
    min-width: 100px;
    max-width: 100px;

    span {
      margin-left: 5px;
      cursor: pointer;

      &.active {
        color: #5c47a7;
      }
      &:hover {
        color: #86ff00;
      }
    }
  }
  .projects {
    list-style: none;
    padding-left: 0;
    // max-width: 1024px;
    // margin: 0 auto;

    h2 {
      color: #2c3e50;
      word-wrap: break-word;
      hyphens: auto;
      font-size: 1em;

      @media all and (min-width: 512px) {
         font-size: 1.2em;
      }
      @media all and (min-width: 1024px) {
        font-size: 1.6em;
      }
    }
    a {
      text-decoration: none;
    }
    a:hover h2 {
      color: #86ff00;
    }
    &.grid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      grid-column-gap: 2em;
      grid-row-gap: 1em;
      padding: 0 10px;

      @media all and (min-width: 512px) {
         grid-template-columns: repeat(2, minmax(0, 1fr));
      }
      @media all and (min-width: 1024px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        padding: 0;
      }

      img {
        max-width: 100%;
      }
    }
    &.list {
      li {
        display: block;
        text-align: left;
      }
    }
  }
</style>
